import { render, staticRenderFns } from "./allIndent.vue?vue&type=template&id=8b18a104&scoped=true&"
import script from "./allIndent.vue?vue&type=script&lang=js&"
export * from "./allIndent.vue?vue&type=script&lang=js&"
import style0 from "./allIndent.vue?vue&type=style&index=0&id=8b18a104&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b18a104",
  null
  
)

export default component.exports